import OtherField from "../components/Svgs/Categories/OtherField";
import IconDefault from "../components/Svgs/Categories/IconDefault";
import {Bible} from "../components/Svgs/Categories/Bible";
import {Theology} from "../components/Svgs/Categories/Theology";
import {Philosophy} from "../components/Svgs/Categories/Philosophy";
import {SacredMusic} from "../components/Svgs/Categories/SacredMusic";
import {Culture} from "../components/Svgs/Categories/Culture";
import {CatholicBook} from "../components/Svgs/Categories/CatholicBook";
import {CatholicMass} from "../components/Svgs/Categories/CatholicMass";
import {CatholicDocs} from "../components/Svgs/Categories/CatholicDocs";
import {ChantIcon} from "../components/Svgs/Categories/ChantIcon";
import {ChristmasIcon} from "../components/Svgs/Categories/ChristmasIcon";
import {MassLiturgy} from "../components/Svgs/Categories/MassLiturgy";
import {SeasonLiturgy} from "../components/Svgs/Categories/SeasonLiturgy";
import {JesusGod} from "../components/Svgs/Categories/JesusGod";
import {MariaMother} from "../components/Svgs/Categories/MariaMother";
import {Saint} from "../components/Svgs/Categories/Saint";
import {OtherMusic} from "../components/Svgs/Categories/OtherMusic";
import CatholicChurch from "../components/Svgs/Categories/CatholicChurch";
import {FaithCatholic} from "../components/Svgs/Categories/FaithCatholic";
import {CatholicDoctrine} from "../components/Svgs/Categories/CatholicDoctrine";
import {ChristianMission} from "../components/Svgs/Categories/ChristianMission";
import {Spiritual} from "../components/Svgs/Categories/Spiritual";
import {LifeCatholic} from "../components/Svgs/Categories/LifeCatholic";

const categoryIcons = {
  "linh-vuc-khac": OtherField,
  "default": IconDefault,
  "loi-chua": Bible,
  "triet-hoc": Philosophy,
  "than-hoc": Theology,
  "thanh-nhac": SacredMusic,
  "van-hoa": Culture,
  "kinh-thanh": Bible,
  "giao-ly": CatholicBook,
  "van-kien": CatholicDocs,
  "phung-vu": CatholicMass,
  "thanh-ca": ChantIcon,
  "nhac-giang-sinh" : ChristmasIcon,
  "phung-vu-thanh-le" : MassLiturgy,
  "mua-phung-vu" : SeasonLiturgy,
  "thien-chua" : JesusGod,
  "duc-me" : MariaMother,
  "cac-thanh" : Saint,
  "chu-de-khac" : OtherMusic,
  "giao-hoi" : CatholicChurch,
  "duc-tin" : FaithCatholic,
  "giao-huan" : CatholicDoctrine,
  "su-vu-muc-vu" : ChristianMission,
  "thieng-lieng" : Spiritual,
  "doi-song" : LifeCatholic,
};
export default categoryIcons;
